export const optimizeImage = (file, MAX_IMAGE_SIZE = 250 * 1024) => {
  return new Promise((resolve) => {
    if (file.size <= MAX_IMAGE_SIZE) {
      return resolve(file); // ✅ L'image est déjà sous 250 Ko, pas besoin de compression
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Définir la taille max (largeur max de 1024px pour garder une bonne qualité)
        const MAX_WIDTH = 1024;
        let scaleFactor = MAX_WIDTH / img.width;
        if (scaleFactor > 1) scaleFactor = 1; // Ne pas agrandir l'image

        canvas.width = img.width * scaleFactor;
        canvas.height = img.height * scaleFactor;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Convertir en Blob (JPEG qualité 0.7)
        canvas.toBlob(
          (blob) => {
            resolve(new File([blob], file.name, { type: "image/jpeg" }));
          },
          "image/jpeg",
          0.7
        );
      };
    };
  });
};

export const replaceImageUrls = (content, images) => {
  let newContent = content;
  images.forEach(({ oldUrl, newUrl }) => {
    newContent = newContent.replace(oldUrl, newUrl);
  });
  return newContent;
};
